import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LotteryGroup from "../component/dahboardComponent/LotteryGroup";
import Lotteryhit from "../component/dahboardComponent/Lotteryhit";
import Optiontap from "../component/dahboardComponent/Optiontap";
import { getAllLottery } from "../features/lotteryReducer";


const Dashboard = () => {
  const allLottery = useSelector(state => state.lottery.allLottery)
  const dispatch = useDispatch()
  // const navigate = useNavigate()
  React.useEffect(() => {
    dispatch(getAllLottery());
    // if(!allLottery){
    //     navigate('/authFail')
    // }
  }, [])
  

  return (
    <div className="min-h-screen md:pb-20 bg-[#f8eede]">
      {/* <Lotteryhit /> */}
      <Optiontap />
      <LotteryGroup lottery={allLottery}/>
    </div>
  );
};

export default Dashboard;
